// ABOUTME: Creates the "Custom work order fields" menu item for the navbar.
// ABOUTME: Links to PackManager when configured, otherwise shows a disabled tooltip.

import { Tooltip } from "@nulogy/components";
import Codenames from "policies/Codenames";
import React from "react";
import styled from "styled-components";

const DisabledMenuItem = styled.span(({ theme }) => ({
  color: theme.colors.grey,
  cursor: "not-allowed",
  display: "block",
  fontSize: theme.fontSizes.medium,
  fontWeight: theme.fontWeights.medium,
  lineHeight: theme.lineHeights.base,
  padding: `${theme.space.x1} ${theme.space.x2}`,
}));

const DISABLED_TOOLTIP_TEXT = `Custom work order fields cannot be configured until ${Codenames.Packmanager} site and account UUIDs have been specified for the Production Scheduling site.`;

function CustomWorkOrderFieldsDisabled() {
  return (
    <Tooltip tooltip={DISABLED_TOOLTIP_TEXT}>
      <DisabledMenuItem>Custom work order fields</DisabledMenuItem>
    </Tooltip>
  );
}

export function customWorkOrderFieldsMenuItem({ applicationContext }) {
  const { packmanagerUrl } = applicationContext;
  const { customWorkOrderField1Id } = applicationContext.site;

  if (customWorkOrderField1Id) {
    const href = `${packmanagerUrl}/custom_work_order_fields/${customWorkOrderField1Id}/custom_work_order_field_values`;
    return {
      href,
      name: "Custom work order fields",
      openInNew: true,
    };
  }

  return {
    name: "Custom work order fields",
    render: () => <CustomWorkOrderFieldsDisabled />,
  };
}
